export const fiscalCodeRegex =
  /^([A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1})$|([0-9]{11})$/;

export const regexOnlyStringNumericWithSpecialCharacters = /^([A-Za-z]*[0-9]*[ -.,']*)*$/gi;

export const regexalphaNumericWithDotSlash = /^([0-9a-zA-Z/ \.\-])*$/gi;

export const regexSurnameWithApex = /^\w+[']\w+$/gi;

export const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/gi;

export const regexOnlyNumber = /^\d+$/gi;

export const regrexOnlyNumberWithoutGlobal = /^\d+$/i;

export const regexYear = /^\d{4}$/gi;

export const regVolRegex = /^([R]{1}[A-Za-z0-9]{2})$/;

export const regexOnlyLetters = /^[a-zA-Z]+$/gi;

export const volumeRegex = /^[a-zA-Z]\d+$/gi;

export const portionRegex = /^[12]{1}$/gi;

export const portionRegexWithoutGlobal = /^[12]{1}$/i;

export const seriesRegex = /^[ABC]{1}$|^[C][123]$/gi;

export const capRegex = /^[0-9]{5}$/gi;

export const belfioreCodeRegex = /^[a-zA-Z][0-9]{2,3}$/gi;

export const alphanumericRegex = /^[a-zA-Z0-9 ]+$/gi;

/**
 * @deprecated
 * use regexCognome e regexNome
 */
export const diacriticRegex = /^[a-zA-Z0-9À-ž]+$/gim;

export const regexNome = /^[\p{Script=Latin}\s.\/'’-]+$/giu;

export const regexCognome = /^[\p{Script=Latin}\s.\/'’-]+$/giu;

/**
 * @deprecated
 * use regexCognome e regexNome
 */
export const nameSurnameRegex = /^[a-zA-Z0-9.\-' ]+$/gi;

/**
 * @deprecated
 * use regexCognome e regexNome
 */
export const nameSurnameMoreCharactersRegex = /^[a-zA-Z0-9.\-'-*-’ ]+$/gi;

/**
 * @deprecated
 * use regexCognome e regexNome
 */
export const nameSurnameMoreCharactersAccentsRegex = /^[a-zA-Z0-9.\-'-*-’À-ž ]+$/gi;

export const phoneNumberRegex = /^\+?\d{2}[- ]?\d{3}[- ]?\d{5}$/gi;

export const onlyDiacriticRegex = /[À-ž]+/gim;

/**
 * @deprecated
 * use regexCognome e regexNome
 */
export const regexNotSpacesAndCharactersExceptUnderscoreAndHypen = /^[a-zA-Z0-9_-]*$/;

/**
 * @deprecated
 * use regexCognome e regexNome
 */
//create an regex which does not accept any spaces and characters except underscore, hypen and dot
export const regexNotSpacesAndCharactersExceptUnderscoreAndHypenAndDot = /^[a-zA-Z0-9_.-]*$/;

export const regexParentesi = /[()]+/gim;

export const regexSlash = /[/]+/gim;

export const regexAt = /[@]+/gim;

export const regexFilePractice = /^((application\/pdf)|(image\/\w+))$/gi;

export const regexNumericFiscalCode = /^[0-9]+$/;

export const idActRegex = /^[0-9]{1,20}-[0-9]{1,20}-[0-9]{1,20}-[0-9]{1,20}$/gi;
